import React, { useContext } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { DEFAULT_ELEVATION } from 'assets/theme';
import { UiContext } from 'uiContext';

export default function StatBlock({
  text,
  icon,
  value,
  timeText,
}: {
  text: string;
  icon: React.ReactNode;
  value: string;
  timeText: string;
}) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  return (
    <Paper
      elevation={DEFAULT_ELEVATION + 1}
      sx={{
        display: 'grid',
        alignItems: 'center',
        gridTemplateColumns: '1fr auto',
        gridTemplateRows: 'auto auto',
        py: sp.s25,
        px: sp.s50,
        gap: '8px',
      }}
    >
      <Typography variant="f12">{text}</Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        {icon}
      </Box>
      <Typography variant="f24">{value}</Typography>
      <Typography
        sx={{ color: 'text.secondary', alignSelf: 'end', paddingBottom: 0.5 }}
        variant="f10"
      >
        {timeText}
      </Typography>
    </Paper>
  );
}
